import React from "react";
import classNames from "classnames";
import { getString } from "./strings";
import { Language, State } from "../core";

import "./ThankYou.scss";

interface ThankYouProps {
  state: State;
  language: Language;
  responseNumber: number;
}
export const ThankYou: React.FC<ThankYouProps> = React.memo(
  ({ state, language, responseNumber }) => {
    return (
      <div
        className={classNames("thankYou", {
          isVisible: state.state === "sent"
        })}
      >
        {getString(language, "lessonComplete").replace(
          "{}",
          "" + responseNumber
        )}
      </div>
    );
  }
);
